import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { ConfirmSubscriptionPage } from './confirm-subscription.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: ConfirmSubscriptionPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [ConfirmSubscriptionPage],
})
export class ConfirmSubscriptionPageModule {}
